import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const VisualizerDriftAmplitudeXListItem = (props) => {
    const { amplitudeX, updateVisualizerSettings } = props;

    const onAmplitudeXChange = (value) => updateVisualizerSettings({ drift: { amplitudeX: value } });

    return (
        <SliderListItem
            title='X Distance'
            displayMultiplier={2}
            value={amplitudeX}
            min={0}
            max={100}
            step={1}
            onValueChange={onAmplitudeXChange}
            toolTip='Horizontal movement distance.'
        />
    );
};

const mapStateToProps = (state) => {
    const { amplitudeX } = state.createPreview.present.videoSettings.visualizer.drift;
    return { amplitudeX };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftAmplitudeXListItem);
